import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { Popup } from "@/Common/Components/Modals/Popup";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IPatientHistoryPrivateBillsProps } from "@/Patient/Components/History/PrivateBillControl";
import { PrivateBillView } from "@/Patient/Components/History/PrivateBillView";

class PrivateBillPopup extends React.Component<IPatientHistoryPrivateBillsProps, any> {
    private id = "privateBillPopup";

    public componentDidMount(): void {
        var elem = $("#" + this.id);
        var cnt = document.body;
        var dragOptions = {
            containment: cnt,
            handle: ".p-header",
            stop: function() {
                elem.draggable("destroy");
                window.setTimeout(() => elem.draggable(dragOptions), 80);
            }
        };

        elem.draggable(dragOptions);
    }

    public componentWillUnmount(): void {
        sessionStore.hideGlobalOverlay();
    }

    public render(): JSX.Element {
        return (
            <div id={this.id} onClick={this.stopPropagation.bind(this)} className="portfolio request-popup">
                {this.props.Model.get("IsInvalidPopupOpen") === true && (
                    <Popup>
                        <div className="p-body" />
                        <div className="p-footer">
                            <div className="text-right">
                                <button className="btn btn-default">{cacheStore.GetString("CancelLabel")}</button>
                                <button className="btn btn-danger">{cacheStore.GetString("InvalidLabel")}</button>
                            </div>
                        </div>
                    </Popup>
                )}
                <div className="row p-header no-side-margins no-bottom-margin">
                    <div className="col-lg-12">
                        <a className="close" onClick={this.OnCloseOperation.bind(this)} aria-label="Close">×</a>
                        <h3 className="uppercase">{cacheStore.GetString("PrivateBillingLabel")}</h3>
                    </div>
                </div>

                <div className="row no-bottom-margin">
                    <div className="col-lg-12">
                        <PrivateBillView
                            Model={this.props.Model}
                            BillableServicesModel={this.props.BillableServicesModel}
                            DisplayFullWidth={this.props.DisplayFullWidth}
                            DoNotRenderAsScrollable={true}
                            IsPopup={true}
                            PrintOp={this.props.PrintOp}
                            CloseInvalidOp={this.props.CloseInvalidOp}
                            SaveInvalidationOp={this.props.SaveInvalidationOp}
                            InvalidateOp={this.props.InvalidateOp}
                            InvalidationChangeOp={this.props.InvalidationChangeOp}
                            PatientModel={this.props.PatientModel}
                            DisableButtons={false}
                            OnButtonClick={null}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <div className="p-footer">
                            <div className="row">
                                <div className="col-lg-12 text-right">
                                    <ButtonControl
                                        className="btn btn-default push-right-5"
                                        onClick={() => sessionStore.dispatch(this.props.OnCloseOperation)}
                                        label={cacheStore.GetString("CancelLabel")}
                                        dataCy="privateBillPopup-cancel"
                                    />
                                    {this.props.Model.get("IsInvalid") === false && this.props.Model.get("CanInvalidateBill") && (
                                        <ButtonControl
                                            className="btn btn-danger push-right-5"
                                            onClick={() => sessionStore.dispatch(LocalPatientOperations.MedicalNote.Billing_Invalidate)}
                                            label={cacheStore.GetString("InvalidLabel")}
                                            dataCy="privateBillPopup-invalid"
                                        />
                                    )}
                                    <ButtonControl
                                        className="btn btn-primary"
                                        onClick={() => sessionStore.dispatch(LocalPatientOperations.MedicalNote.Billing_Print)}
                                        label={cacheStore.GetString("PrintLabel")}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private OnCloseOperation(e: React.MouseEvent): void {
        e.preventDefault();
        var operation = new LocalEvent(this.props.OnCloseOperation);
        LocalEventDispatcher.dispatch(operation);
    }

    private stopPropagation(e: React.MouseEvent): void {
        e.stopPropagation();
    }
}

export { PrivateBillPopup };
